import './index.scss';
class Header extends React.Component {
    state = {
        spread: false
    }

    toggleSpread = (dep) => {
        if(typeof dep === 'string') {
            if(dep === this.props.dep) return;
            this.props.setDep(dep);
        }
        this.setState({
            spread: !this.state.spread
        });
    }
    render() {
        const {searchClick, deps, dep, placeholder='目的地/主题/景点', moreDep = true, className = ''} = this.props;
        const {spread} = this.state;
        return (
            <div className={`m-hbar ${className}`}>
                <div className="m-hbar-wrap">
                    <div className="left" onClick={this.toggleSpread}><span className="yo-ico ico-location"></span> {dep}出发 {moreDep && <span className="yo-ico ico-arrow">{spread ? '' : ''}</span>}</div>
                    <div className="search" onClick={() => {
                        searchClick();
                    }}><span className="yo-ico"></span>{placeholder}</div>
                </div>
                {spread && <div className="city-choose">
                    {deps.map((item, index) => {
                        return <div className={`city-choose-item ${item.name === dep ? 'active' : ''}`} onClick={() => {
                            this.toggleSpread(item.name);
                        }} key={index}>{item.name}</div>;
                    })}
                </div>}
            </div>
        );
    }
}
Header.defaultProps = {
    searchClick: () => {},
    deps: [],
    dep: '北京',
    setDep: () => {}
};

export default Header;